import { useRouter } from 'next/router';
import BookingActionsBox from 'components/ui/BookingActionsBox/BookingActionsBox';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import usePreApproveCardShow from '../hooks/usePreApproveCardShow';
import { SpecialMessageProps } from './types';

export default function BookInquiryBoxActions({
  index,
  booking,
  userType,
  lastEdits: { preApproval },
}: SpecialMessageProps) {
  const router = useRouter();
  const rudderTrack = useRudderStackTrack();

  const bookNowAction = () => {
    rudderTrack('booking_action_book_now', {
      bookingId: booking.id,
      bookingState: booking.state,
      action: 'book_now_pre_approved',
      location: 'conversation_action_box',
    });

    router.push(`/a/bookings/${booking.id}/book_now`);
  };

  const [, hidePreApproveBox] = usePreApproveCardShow();

  return (
    index === preApproval &&
    booking?.state_read_by_user === 'pre-approved' &&
    userType === 'renter' &&
    // @ts-ignore
    booking.can_be_booked &&
    booking.special_offer_price === 0 && (
      <BookingActionsBox
        title={<span>Your inquiry has been pre-approved by {booking?.owner?.first_name}!</span>}
        ctaText="Book now"
        subHeading="You can book this inquiry and it will automatically be approved. Book now to reserve your boat."
        userType="renter"
        onSubmit={bookNowAction}
        showCloseButton={false}
        showSubtitle={false}
        onClose={hidePreApproveBox}
      />
    )
  );
}
